export default __webpack_public_path__ + "static/media/groundplan_s_108.d684ccbb.png";